module.exports = __webpack_public_path__ + "static/media/izlozba (20).e29cc76b.JPG";